export default "__VITE_ASSET__uRzq9tx3__"